module.exports = __webpack_public_path__ + "static/images/components/BattleWizard/components/Status/images/background.f16e7569.png";


//////////////////
// WEBPACK FOOTER
// ./components/BattleWizard/components/Status/images/background.png
// module id = 2525
// module chunks = 11